<div class="terms-wrapper">
    <div class="terms-content">

        <markdown [src]="markdownPath"></markdown>


        <hr />
        <div class="terms-history">
            <p>利用規約の履歴:</p>
            <markdown [src]="historyMarkdownPath"></markdown>
        </div>
    </div>

</div>